/* tslint:disable */
/* eslint-disable */

/**
 * Nom des méthodes
 */
export enum WebApiSignalRClientMethod {
  NotifyEIdCard = 'NotifyEIdCard',
  PrintCodesAccesVisiteur = 'PrintCodesAccesVisiteur',
  PrintRachatQuotaGlobal = 'PrintRachatQuotaGlobal',
  PrintDemandeAcces = 'PrintDemandeAcces',
  PrintDemandeTransport = 'PrintDemandeTransport',
  PrintBonCommande = 'PrintBonCommande'
}
